/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type DevelopmentOrganisation_organisation$ref: FragmentReference;
declare export opaque type DevelopmentOrganisation_organisation$fragmentType: DevelopmentOrganisation_organisation$ref;
export type DevelopmentOrganisation_organisation = {|
  +name: ?string,
  +formattedAddress: ?string,
  +primaryImage: ?{|
    +url: string
  |},
  +$refType: DevelopmentOrganisation_organisation$ref,
|};
export type DevelopmentOrganisation_organisation$data = DevelopmentOrganisation_organisation;
export type DevelopmentOrganisation_organisation$key = {
  +$data?: DevelopmentOrganisation_organisation$data,
  +$fragmentRefs: DevelopmentOrganisation_organisation$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DevelopmentOrganisation_organisation",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "formattedAddress",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "primaryImage",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Organisation",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '4fc6875eb5842cd18f03e2106cd07f94';

export default node;
